// ─── Character id → PopupPhone conversation key ─────────────────────────────
//
// phone_conversations.char_key stores PopupPhone's SHORT keys ('sebastian',
// 'kya'), while the character roster uses long ids ('sebastian_vamp',
// 'sebastian_siren', 'kya_sg1'). Finding 8: DMView queried phone memory with
// the LONG id, so phone-call context never reached DMs for any character
// whose id differs from their phone key — and the map that fixes it lived
// inline in SixGuysRP where nothing else could import it.
//
// Multiple route-generations of the same person share one phone thread on
// purpose (kya_sg1 and kya_sg3 are both 'kya'): the phone is theirs, not the
// route's. Characters with no phone presence (e.g. achelois) are absent —
// callers fall back to the raw id, which simply finds no thread.
export const CHAR_ID_TO_PHONE_KEY = {
  cruz: 'cruz', evelyn: 'evelyn', bryce: 'bryce', audrey: 'audrey',
  ford: 'ford', trix: 'trix',
  kya_sg1: 'kya', kya_sg3: 'kya',
  sebastian_siren: 'sebastian', sebastian_vamp: 'sebastian',
  dillon: 'dillon', ezra: 'ezra',
  alistair: 'alistair', dimitri: 'dimitri', lance: 'lance',
  lachesis: 'lachesis', atropos: 'atropos', kieran: 'kieran',
  peter: 'peter', alyce_char: 'alyce', allie: 'allie',
};

export function charIdToPhoneKey(charId) {
  return CHAR_ID_TO_PHONE_KEY[charId] || null;
}
